/**
 * コモンクラス
 * @constructor
 */
class SpAncMenu {
    constructor() {

    }
    /**
     * コモン
     */
    init() {
      this.ancMenu();
    }
    ancMenu() {
        $('#js-menuBtn').on('click', function () {
            $(this).toggleClass('is-active');
            $('#js-menu').toggleClass('is-active');
        });
        $('.l-main__ancNavItem button').on('click', function () {
            $('#js-menuBtn').removeClass('is-active');
            $('#js-menu').removeClass('is-active');
        });
    }

}

export default SpAncMenu;
